import { produce } from 'immer';
import { CLEAR_COMMON_STATE, CLEAR_REBUY_WINDOW, SET_IS_COLUMN_LAYOUT_MODE, SET_IS_KEYBOARD_CAPTURING_INPUT_ACTIVE, SET_NEXT_TOURNEY_FROM_INBOUND, SHOW_REBUY_WINDOW_FROM_INBOUND } from '../actions/commonActions';
const initialState = {
    isKeyboardCapturingInputActive: false,
    isColumnLayoutMode: false
};
const commonReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_COMMON_STATE: {
                return initialState;
            }
            case SET_IS_KEYBOARD_CAPTURING_INPUT_ACTIVE: {
                draft.isKeyboardCapturingInputActive = action.payload;
                break;
            }
            case SHOW_REBUY_WINDOW_FROM_INBOUND: {
                const { numJacksNeeded, numChipsNeeded, isFromPlayerAction, eventMessage, allowFreeRebuy } = action.payload;
                if (!isFromPlayerAction) {
                    // ignore the rebuy window sent at room enter time
                    delete draft.rebuyWindow;
                }
                else {
                    draft.rebuyWindow = { numJacksNeeded, numChipsNeeded, isFromPlayerAction, eventMessage, allowFreeRebuy };
                }
                break;
            }
            case CLEAR_REBUY_WINDOW: {
                delete draft.rebuyWindow;
                break;
            }
            case SET_NEXT_TOURNEY_FROM_INBOUND: {
                const { tourneyName, roomId, secondsUntilStart, serverStartTime, mttId, sponsorString } = action.payload;
                draft.nextTourney = {
                    tourneyName,
                    roomId,
                    serverStartTime,
                    mttId,
                    sponsorString,
                    startTimestampMs: performance.now() + secondsUntilStart * 1000
                };
                break;
            }
            case SET_IS_COLUMN_LAYOUT_MODE: {
                if (draft.isColumnLayoutMode !== action.payload) {
                    draft.isColumnLayoutMode = action.payload;
                }
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default commonReducer;
